module.exports = __webpack_public_path__ + "static/media/GIS_logotype_reversed.b51ae4cb.svg";